import i18n from "../../../i18n";

const TITLE_DICT = {
    olivia_crm: { label: "OLIVIA_CRM", navigateTo: "/" },
    example: { label: i18n.t("headers.main") },
};

export default TITLE_DICT;
